module.exports = __webpack_public_path__ + "static/uni_philander-5e99633e9d66dbce4fb1f498bebfa300.png";